import { render, staticRenderFns } from "./headTop.vue?vue&type=template&id=2befe163&"
import script from "./headTop.vue?vue&type=script&lang=js&"
export * from "./headTop.vue?vue&type=script&lang=js&"
import style0 from "./headTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports